import {AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, Subscription}                                 from 'rxjs';
import {debounceTime, filter, first, map, skip}                                  from 'rxjs/operators';
import {
  ApDynComponentComponent
}                                                                                from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {FormStore}                                                               from '../../stores/layout/form.store';
import {
  ApNutrientPlanningComponent
}                                                                                from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning.component';
import {
  SettingsStore
}                                                                                from '../../stores/base-data/settings.store';
import {
  CampaignYearStore
}                                                                                from '../../stores/login/campaignyear.store';
import {
  BasicFertilisationSummariesStore
}                                                                                from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {
  CropTypeStore
}                                                                                from '../../stores/base-data/crop.types.store';
import {FieldStore}                                                              from '../../stores/farm/field.store';
import {
  TranslationStore
}                                                                                from '../../stores/translation/translation.store';
import {
  FertilizerStore
}                                                                                from '../../stores/base-data/fertilizer.store';
import {
  ApDynGridPagerConfigBase
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  GridBuilderService
}                                                                                from './configs/plan-books-grid-builder.service';
import {
  ApUtilService
}                                                                                from '../../ap-utils/service/ap-util.service';
import {
  ApNutrientBookingComponent
}                                                                                from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-booking.component';
import {
  GetElementService
}                                                                                from '../../ap-utils/service/ap-get-element.service';
import {LoginStore}                                                              from '../../stores/login/login.store';
import {
  RouterStore
}                                                                                from '../../stores/router/router.store';
import {
  StatisticStore
}                                                                                from '../../stores/statistic/statistic.store';
import {
  GetRoundNumericService
}                                                                                from '../../ap-utils/service/get-round-numeric.service';
import {ApElementOxydTypeEnum, ApStatsType, MapViewCurrentMenu, MapViewMode}     from '../../ap-interface';
import {
  ApNutrientStatisticService
}                                                                                from '../service/ap-nutrient-statistic.service';
import {
  ApDateService
}                                                                                from '../../ap-core/services/ap-date-service';
import {
  NutrientManagementService
}                                                                                from '../service/nutrient-management.service';
import {
  NutrientStore
}                                                                                from '../../stores/nutrients/nutrient.store';
import {PagerBuilder} from './configs/pager-builder';
import {
  ApIcons
}                     from '../../ap-interface/enums/layout/ap-icons';
import {
  ApTooltipContentService
}                     from '../../ap-utils/service/ap-tooltip-content.service';
import {GetRoundNumericPipe}                                                     from '../../ap-utils';
import {
  ApNutrientService
}                                                                                from '../../ap-utils/service/ap-nutrient.service';
import {
  ApTranslationService
}                                                                                from '../../ap-utils/service/ap-translation.service';
import {
  TaskManagementAction
}                                                                                from '../../task-management/task-management.types';
import {
  ApRoleTypeService
}                                                                                from '../../services/common/ap-role-type.service';
import {
  FertilizerService
}                                                                                from '../../services/data/fertilizer.service';
import {
  BaseFertilizationCommonService
}                                                                                from '../service/base-fertilization-common.service';
import {MapStore}                                                                from '../../stores/map/map.store';
import {
  CropRotationStore
}                                                                                from '../../stores/farm/crop.rotation.store';
import {
  PlanningEntryComponentDataType
}                                                                                from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {
  FieldArchiveStore
}                                                                                from '../../stores/farm/field-archive.store';
import {ObjectFactory}                                                           from 'ts-tooling';
import {
  MapViewStore
}                                                                                from '../../stores/layout/mapview.store';
import {
  GenericChartConfig
}                                                                                from '../../statistics/components/charts/ap-generic-chart.types';
import IBasicFertilisationSummaries = Data.TaskManagement.IBasicFertilisationSummaries;
import IBasicFertilisationPlanBooks = Data.TaskManagement.IBasicFertilisationPlanBooks;

@Component({
  selector: 'ap-nutrient-planning',
  template: `
    <ap-dyncomponent [caption]="'Global__Plannings'"
                     [canCreate]="(loading$ | async) === false"
                     [headerIcon]="'ap-icon-base-fertilization'"
                     [columns]="columns"
                     [loading$]="loading$"
                     [items]="items$ | async"
                     [pager]="pager"
                     (create)="onCreate()"
                     [selectable]="{checkboxOnly: false, mode: 'single'}">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApNutrientManagementPlanningComponent implements OnInit, OnDestroy, AfterContentInit {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns: ApDynGridColumnConfigBase[] = [];
  public items$: Observable<any[]>;
  public pager: ApDynGridPagerConfigBase;
  public loading$: Observable<boolean>;
  private _statisticUpdateRequested = new EventEmitter<void>();

  private _subscriptions: Subscription[] = [];
  private _isOnCreatePressed = false;

  constructor(private formStore: FormStore,
              private settingsStore: SettingsStore,
              private campaignYearStore: CampaignYearStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private cropTypeStore: CropTypeStore,
              private fieldStore: FieldStore,
              private translationStore: TranslationStore,
              private fertilizerStore: FertilizerStore,
              private gridBuilder: GridBuilderService,
              private elementService: GetElementService,
              private loginStore: LoginStore,
              private routerStore: RouterStore,
              private statisticStore: StatisticStore,
              private cropRotationStore: CropRotationStore,
              private roundNumericService: GetRoundNumericService,
              private nutrientStatisticService: ApNutrientStatisticService,
              private dateService: ApDateService,
              private nutrientManagementService: NutrientManagementService,
              private nutrientStore: NutrientStore,
              private tooltipContentService: ApTooltipContentService,
              private roundNumericPipe: GetRoundNumericPipe,
              private nutrientService: ApNutrientService,
              private translationService: ApTranslationService,
              private mapStore: MapStore,
              private baseFertilizationCommonService: BaseFertilizationCommonService,
              private fertilizerService: FertilizerService,
              private fieldArchiveStore: FieldArchiveStore,
              private mapViewStore: MapViewStore) {
  }

  public ngOnInit(): void {
    this.statisticStore.removeStatisticData();
    this.fieldStore.changeSelectedField([]);
    this.loading$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.cropTypeStore.Listen(s => s.loading),
      this.basicFertilisationSummariesStore.Listen(s => s.loading),
      this.cropRotationStore.HistoryLoading$
    ]).pipe(
      map(loadingItems => loadingItems.some(x => x))
    );
    this._buildGrid();
  }

  public ngAfterContentInit(): void {
    // Auf Farm/EJ-Wechsel reagieren und Summaries neu laden
    this._subscriptions.push(this.dynComponent.gridInitialized.subscribe(() => {
      this._subscriptions.push(this.items$.subscribe(items => {
        const itemToSelect = items.find(x => x.Id === this.baseFertilizationCommonService.selectedSummaryId);
        if (itemToSelect) {
          this.baseFertilizationCommonService.setSelectedSummaryKey(undefined);
          this.dynComponent.dynGrid.gridPaging.setSelectedKeys([itemToSelect.Id]);
        }
      }));
    }));
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).pipe(skip(1)).subscribe(() => {
      this.basicFertilisationSummariesStore.loadBasicFertilisationSummaries();
    }));
    this._subscriptions.push(this.mapStore.Layers.OnLayerChange.subscribe(() => {
      // in order to show the geometry of the planning we reuse the taskmanagement layer
      this.mapStore.Layers.TaskManagementLayer.Visibility = this.mapStore.Layers.NutrientPlanningLayer?.Visibility;
    }));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(_ => this._selectionChange()));
    this._subscriptions.push(combineLatest([
      this.routerStore.Listen(s => s),
      this.items$,
      this.basicFertilisationSummariesStore.Listen(s => s.loading)
    ]).pipe(
      filter(([routerStoreData, gridItems, gridItemsLoading]) =>
        routerStoreData.url?.startsWith('/nutrients/planning') && routerStoreData.queryParams['id'] !== undefined && gridItems?.length !== 0 && !gridItemsLoading),
      first(),
    ).subscribe(([routerStoreData, gridItems]) => {
      const isBooking = routerStoreData.queryParams['action'] === TaskManagementAction.Booking;
      const targetComponent = isBooking ? ApNutrientBookingComponent : ApNutrientPlanningComponent;
      let targetGridItem = gridItems.find(_ => _.Id === routerStoreData.queryParams['id']);
      if (routerStoreData.queryParams['action'] === TaskManagementAction.Edit) {
        targetGridItem = targetGridItem?.SourceItem;
      }
      const dataObject: any = isBooking
        ? {Summary: targetGridItem, FieldIdToSelect: null}
        : {
          Summary: targetGridItem,
          Type: targetGridItem ? PlanningEntryComponentDataType.Create : PlanningEntryComponentDataType.Edit
        };
      setTimeout(() => {
        this.formStore.openForm({component: targetComponent, data: dataObject});
        if (routerStoreData.queryParams['url']) {
          this._subscriptions.push(this.formStore.FormClose$.subscribe(() => this.routerStore.navigate([routerStoreData.queryParams['url']])));
        }
      }, 0);
    }));
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
      // trigger refresh of selection and map after entryComponent (e.g. 'NEW') closed
      if (this._isOnCreatePressed) {
        this._isOnCreatePressed = false;
        setTimeout(() => {
          this._handleLegendsAndLayers(this.dynComponent.getSelectedItems().length);
          this._selectionChange();
        }, 1);
      }
    }));
    this._subscriptions.push(this.mapStore.Layers.OnLayerChange.subscribe(() => {
      this._handleLegendsAndLayers(this.dynComponent.getSelectedItems().length);
    }));
    this._subscriptions.push(this._statisticUpdateRequested.pipe(
      debounceTime(100)).subscribe(_ => this._generateStats()));
    this._subscriptions.push(this.items$.subscribe(_ => this._statisticUpdateRequested.emit()));
    this._subscriptions.push(
      combineLatest([
        this.mapViewStore.Listen(s => s.mode),
        this.mapViewStore.Listen(s => s.currentMenu)
      ]).subscribe(([mapMode, mapMenu]) => {
          if (mapMode !== MapViewMode.HIDE && mapMenu === MapViewCurrentMenu.STATS) {
            this._statisticUpdateRequested.emit();
          }
        }
      ));
  }

  public ngOnDestroy(): void {
    this.baseFertilizationCommonService.revertLegends();
    this._subscriptions.forEach(s => s?.unsubscribe());
    this.statisticStore.removeStatisticData();
    this.fieldStore.changeSelectedField([]);
  }

  public onCreate(): void {
    this.statisticStore.removeStatisticData();
    if (this.dynComponent.dynGrid.gridPaging.selectedKeys.length !== 0) {
      const selectedSourceItem = (this.dynComponent.dynGrid.gridPaging.items.find(x => x.Id === this.dynComponent.dynGrid.gridPaging.selectedKeys[0]) as any)?.SourceItem;
      this.formStore.openForm({
        component: ApNutrientPlanningComponent,
        data: {
          Summary: ObjectFactory.Copy(selectedSourceItem),
          Type: PlanningEntryComponentDataType.Edit
        }
      });
    } else {
      this.formStore.openForm({
        component: ApNutrientPlanningComponent,
        data: {
          Summary: null,
          Type: PlanningEntryComponentDataType.Create
        }
      });
    }

    this._isOnCreatePressed = true;
  }

  private _selectionChange(): void {
    if (!this.dynComponent?.dynGrid?.gridPaging) {
      return;
    }
    const selectedSummaries = this.dynComponent.dynGrid.gridPaging.selectedItems;
    if (selectedSummaries && selectedSummaries.length > 0) {
      this.baseFertilizationCommonService.onSelectionChange(selectedSummaries[0]['SourceItem'] as IBasicFertilisationSummaries, false);
    } else {
      this.baseFertilizationCommonService.onSelectionChange(null, false);
    }
    this._statisticUpdateRequested.emit();
  }

  private _buildGrid(): void {
    const gridOptions = [
      {
        text: 'Global__Show',
        callback: ApUtilService.createEventEmitter(this._onOneShow.bind(this), this._subscriptions)
      },
      {
        text: 'Global__Export',
        callback: ApUtilService.createEventEmitter(this._onOneExport.bind(this), this._subscriptions)
      },
      {
        text: 'Global__Replan',
        callback: ApUtilService.createEventEmitter(this._onOneReplan.bind(this), this._subscriptions)
      },
      {
        text: 'Admin_Pages_Popups__Book',
        callback: ApUtilService.createEventEmitter(this._onOneBooking.bind(this), this._subscriptions)
      },
      {
        text: 'Global__Delete',
        callback: ApUtilService.createEventEmitter(this._onOneDelete.bind(this), this._subscriptions)
      }
    ];
    if (ApRoleTypeService.hasAgriconRole(this.loginStore.User)) {
      gridOptions.Add({
        text: 'Global__Download',
        callback: ApUtilService.createEventEmitter(this._onOneDownloadPackage.bind(this), this._subscriptions)
      });
    }
    this.columns = this.gridBuilder.PlanBooksGrid(gridOptions);
    const pagerOptions = [
      {
        text: 'Global__Export',
        callback: ApUtilService.createEventEmitter(this._onExport.bind(this), this._subscriptions)
      },
      {
        text: 'Admin_Pages_Popups__Book',
        callback: ApUtilService.createEventEmitter(this._onBooking.bind(this), this._subscriptions)
      },
      {
        text: 'Global__Replan',
        callback: ApUtilService.createEventEmitter(this._onReplan.bind(this), this._subscriptions)
      },
      {
        text: 'Global__Delete',
        callback: ApUtilService.createEventEmitter(this._onDelete.bind(this), this._subscriptions)
      }
    ];
    const iconOptions = [
      {
        icon: ApIcons.PDF,
        callback: ApUtilService.createEventEmitter(this._onPdf.bind(this), this._subscriptions),
        tooltip: 'Global__Save_PDF'
      },
      {
        icon: ApIcons.XLS,
        callback: ApUtilService.createEventEmitter(this._onXls.bind(this), this._subscriptions),
        tooltip: 'Global__Save_EXCEL'
      }
    ];
    this.pager = PagerBuilder.NutrientManagementPager(pagerOptions, iconOptions);

    this.items$ = combineLatest([
      this.basicFertilisationSummariesStore.Summaries$,
      this.cropTypeStore.Listen(s => s.cropTypesNames),
      this.fieldStore.Listen(s => s.data),
      this.campaignYearStore.Listen(s => s.selectedYear),
      this.cropRotationStore.GetHistory$,
      this.baseFertilizationCommonService.gridUpdate$,
      this.fieldArchiveStore.Listen(s => s.loaded)
    ]).pipe(
      filter(([summaries, cropTypesNames, fields,
                campaignYear, cropRotationHistory, isGridUpdateAllowed, fieldArchiveLoaded]) => {
        return !!summaries && !!cropTypesNames && !!fields && !!campaignYear && !!cropRotationHistory && isGridUpdateAllowed && fieldArchiveLoaded;
      }),
      map(([summaries, cropTypesNames]) => {
        return summaries.filter(x => x.BasicFertilisationPlanBooks.some(planBook => !planBook.DeletedAt && !planBook.BookedAt))
          .map((summary) => {
            const area = this.nutrientManagementService.getArea(summary, false);
            const sum = this.nutrientManagementService.getCalculateSumFertilizer(summary, false);
            const productTooltip = this.tooltipContentService.getProductContentInfoTooltip(this._getProductId(summary));
            const fertilizer = this.fertilizerStore.getFertilizer(this._getProductId(summary));
            const fertilizerUnit = this.fertilizerService.getFertilizerUnit(fertilizer);
            const sumTooltip = this.roundNumericPipe.transform(sum, this.settingsStore.FirstSetting.DigitsAfterDecimalPoint) + ' ' + fertilizerUnit;
            const planBookApplicationDates = this.baseFertilizationCommonService.getApplicationDatesData(summary.BasicFertilisationPlanBooks, false);
            return {
              SourceItem: summary,
              Id: summary.Id,
              Status: this.nutrientService.getFertilizerStatus(summary.User_Appl_Mode, false)?.state,
              StatusClass: this.nutrientService.getFertilizerStatus(summary.User_Appl_Mode, false)?.class,
              StatusDesc: this.nutrientService.getFertilizerStatusDescription(summary.User_Appl_Mode, false),
              Crop: cropTypesNames[this._getCropType(summary)],
              Count: this.baseFertilizationCommonService.getPlanBooksFieldsCount(summary.BasicFertilisationPlanBooks, false),
              Area: this.roundNumericService.roundAsNumber(area, this.settingsStore.FirstSetting.DigitsAfterDecimalPoint),
              AreaOriginal: area.toString(10),
              OperationMode: this.translationService.translate(summary.User_Operation_Mode?.Key),
              Product: this.fertilizerService.getFertilizerProductName(fertilizer),
              ProductTooltip: productTooltip,
              ApplicationDate: planBookApplicationDates?.NewestDate,
              ApplicationDateTooltip: planBookApplicationDates?.Tooltip,
              ApplicationDateItalic: planBookApplicationDates?.IsMoreThanOneUniqDate,
              Plannings: summary.BasicFertilisationPlanBooks,
              Note: summary.Title,
              Amount: summary.User_Appl_Rate,
              AmountUnit: summary.User_Appl_Unit?.Id === 1 ? this.fertilizerService.getFertilizerUnit(fertilizer, true) : this.translationStore.FindTranslationForSelectedLanguage(summary.User_Appl_Unit?.Key),
              Sum: sum,
              SumUnit: fertilizerUnit,
              SumTooltip: sumTooltip,
              LeadNutrient: this.baseFertilizationCommonService.getLeadNutrient(summary),
              Min: this.nutrientManagementService.getMin(summary, false),
              Max: this.nutrientManagementService.getMax(summary, false),
              BasicFertilisationPlanBooks: summary.BasicFertilisationPlanBooks,
              P: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistics(0, summary, false), ApElementOxydTypeEnum.P),
              K: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistics(1, summary, false), ApElementOxydTypeEnum.K),
              Mg: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistics(2, summary, false), ApElementOxydTypeEnum.Mg),
              CaO: this.nutrientStatisticService.getAverageNutrientFromStatistics(3, summary, false),
              Statistic: summary.Statistic,
              PlanNumber: summary.PlanNumber,
              FieldIds: this.baseFertilizationCommonService.getFieldIds(summary.BasicFertilisationPlanBooks, false),
              FieldsTooltip: this.baseFertilizationCommonService.getFieldCropsTooltip(summary.BasicFertilisationPlanBooks, false)
            };
          });
      })
    );
  }

  private _getProductId(summary: IBasicFertilisationSummaries): number | null {
    return summary.BasicFertilisationPlanBooks[0]?.Product_Id;
  }

  private _getCropType(summary: IBasicFertilisationSummaries): number | string {
    return summary.BasicFertilisationPlanBooks[0]?.Croptype_Id ?? '';
  }

  private _handleLegendsAndLayers(selectedItems: number): void {
    this.baseFertilizationCommonService.handleLegends(selectedItems ?? 0);
    // in order to show the geometry of the planning we reuse the taskmanagement layer
    this.mapStore.Layers.TaskManagementLayer.Visibility = this.mapStore.Layers.NutrientPlanningLayer?.Visibility;
  }

  private _onXls(): void {
    this.dynComponent.dynGrid.xlsExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsXls();
  }

  private _onPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private _generatePrintFilename(): string {
    return this.dateService.toFarmDate(new Date()).format('YYYY-MM-DD') + '_' +
      this.translationStore.FindTranslationForSelectedLanguage('Global__Plannings');
  }

  private _onExport(dataItem: any): void {
    if (dataItem.items === null || dataItem.items === undefined) {
      return;
    }
    this._onOneExport(dataItem.items[0]);
  }

  private _onOneExport(dataItem: any): void {
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([dataItem.Id]);
    this.baseFertilizationCommonService.redirectSummaryToExportView(dataItem.Id, false, 'nutrients/planning');
  }

  private _onBooking(dataItem: any): void {
    if (dataItem.items === null || dataItem.items === undefined) {
      return;
    }
    this._onOneBooking(dataItem.items[0]);
  }

  private _onOneBooking(dataItem: any): void {
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([dataItem.Id]);
    this.baseFertilizationCommonService.bookPlanBooks(dataItem.SourceItem);
  }

  private _onReplan(dataItem: any): void {
    if (!dataItem?.items || dataItem.items.length <= 0) {
      return;
    }
    this._onOneReplan(dataItem.items[0]);
  }

  private _onOneReplan(dataItem: any): void {
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([dataItem.Id]);
    this.baseFertilizationCommonService.replanSummary(dataItem.SourceItem);
  }

  private _onDelete(dataItem: any): void {
    if (dataItem.items === null || dataItem.items === undefined) {
      return;
    }
    this._onOneDelete(dataItem.items[0]);
  }

  private _onOneDelete(dataItem: any): void {
    this.baseFertilizationCommonService.deleteSummary(dataItem.SourceItem);
  }

  private _onOneShow(dataItem: any): void {
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([dataItem.Id]);
    this.baseFertilizationCommonService.redirectSummaryToShowView(dataItem.Id, false, 'nutrients/planning');
  }

  private _onOneDownloadPackage(dataItem: any): void {
    const summary = dataItem['SourceItem'] as IBasicFertilisationSummaries;
    this.nutrientStore.createNutrientPlanningPackage(summary.Id);
  }

  /**
   * Generates the statistic charts for the selected planbooks.
   * Grouped by product (=series)
   * Grouped by Month/Year (=category/y-axis)
   * @private
   */
  private _generateStats(): void {
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS || this.mapViewStore.getMapViewMode() === MapViewMode.HIDE) {
      return;
    }
    const title = `${this.translationService.translate('Global__Planning')}`;
    let items = this.dynComponent.getSelectedItems() as any[];
    if (!items || items?.length === 0) {
      items = this.dynComponent.items as any[];
    }
    if (!items || items?.length === 0) {
      this.statisticStore.setStatisticData<GenericChartConfig>(
        [], ApStatsType.GenericBars, title, title
      );
      return;
    }

    const chartConfigs: GenericChartConfig[] = [];
    let planBooks = items?.map(item => item?.BasicFertilisationPlanBooks).flat() as IBasicFertilisationPlanBooks[];
    planBooks = planBooks?.filter(pB => pB?.BookedAt == null && pB.DeletedAt == null);
    const chartConfig = this.baseFertilizationCommonService.generateStatChartConfig(planBooks);
    chartConfigs.push(chartConfig);

    this.statisticStore.setStatisticData<GenericChartConfig>(
      chartConfigs, ApStatsType.GenericChart, title, title
    );
  }
}
